import { differenceInYears } from "date-fns";

export const MAX_AGE_IN_YEARS_FOR_CHILD_ACCOUNT = 11;

export const isChildPatient = (dob?: Date) => {
  return (
    !!dob &&
    differenceInYears(new Date(), new Date(dob)) <=
      MAX_AGE_IN_YEARS_FOR_CHILD_ACCOUNT
  );
};
